import { render, staticRenderFns } from "./TranslationSettingsView.vue?vue&type=template&id=407bc284&scoped=true"
import script from "./TranslationSettingsView.vue?vue&type=script&lang=js"
export * from "./TranslationSettingsView.vue?vue&type=script&lang=js"
import style0 from "./TranslationSettingsView.vue?vue&type=style&index=0&id=407bc284&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "407bc284",
  null
  
)

export default component.exports